// src/components/UserProfile/UserProfile.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../gmanewstyle.module.css"; // ⬅️ use shared style file
import logoimage from "../assets/Group -2.png";

const UserProfile = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  const navigate = useNavigate();

  const tp = localStorage.getItem("token");
  const upId = localStorage.getItem("userProfileId");

  useEffect(() => {
    if (!tp || !upId) {
      alert("Missing token or profile ID. Please reload your profile.");
      // continue; we can still try fetch via email decode below
    }
    document.title = "GMA Portal || User Profile";

    const fetchUserProfile = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decodedToken = JSON.parse(atob(token.split(".")[1] || ""));
        const userEmail = decodedToken.email || null;
        if (!userEmail) {
          setLoading(false);
          return;
        }

        const profileResponse = await fetch(
          `https://portal.gmacc.co.za/api/user-profile/email/${encodeURIComponent(
            userEmail
          )}/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const profileData = await profileResponse.json();

        if (profileResponse.ok) {
          setEmail(profileData.cj_email || "");
          setFirstName(profileData.cj_name || "");
          setLastName(profileData.cj_lastname || "");
          setMobileNumber(profileData.cj_cellnumber || "");
          localStorage.setItem("userProfileId", profileData.cj_userprofileid);
        } else {
          setError(profileData.error || "Failed to load profile.");
        }
      } catch {
        setError("Network error loading profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [navigate]);

  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }
      try {
        const decodedToken = JSON.parse(atob(token.split(".")[1] || ""));
        const userEmail = decodedToken.email || null;
        const contact_id = decodedToken.contact_id || null;
        if (!userEmail) {
          setLoadingAccess(false);
          return;
        }
        const response = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email: userEmail, contact_id }),
          }
        );
        const data = await response.json();
        if (response.ok) setUserAccess(data.access || []);
      } catch {
        // ignore
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const userProfileId = localStorage.getItem("userProfileId");
    if (!userProfileId) {
      setError("User profile ID not found.");
      return;
    }

    try {
      const updateResponse = await fetch(
        `https://portal.gmacc.co.za/api/user-profile/update/${userProfileId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            cj_email: email,
            cj_name: firstName,
            cj_lastname: lastName,
            cj_cellnumber: mobileNumber,
          }),
        }
      );
      const updateData = await updateResponse.json();

      if (updateResponse.ok) {
        setSuccessMessage("User profile updated successfully!");
        setError("");
      } else {
        setSuccessMessage("");
        setError(updateData.error || "Failed to update profile.");
      }
    } catch {
      setSuccessMessage("");
      setError("Failed to connect to the server.");
    }
  };

  const handleOwnerPortalClick = () => navigate("/owner-portal");
  const handleTrusteePortalClick = () => navigate("/trustee-portal");
  const handleContractorPortalClick = () => navigate("/contractor-portal");

  return (
    <div className={styles.page}>
      {/* 50/50 split like the statement page */}
      <div className={styles.authFrame}>
        <div className={styles.authMedia} aria-hidden="true"></div>

        {/* Right white form panel */}
        <div className={styles.authPanel}>
          {loading ? (
            <div className={styles.page}>
              <div className={styles.shell}>
                <main className={styles.contentArea}>
                  <div className={styles.panel}>
                    <div className={styles.loadingContainer}>
                      <div className={styles.loadingImage}></div>
                      <p className={styles.loadingText}>Loading...</p>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          ) : (
            <form className={styles.formContainer} onSubmit={handleSubmit}>
              <img
                src={logoimage}
                alt="Gauteng Management Agents"
                className={styles.portalLogo}
              />
              <h1 className={styles.heading}>USER PROFILE</h1>
              <p className={styles.subhead}>
                Update your details below and save your changes.
              </p>

              {error && <p className={styles.errorText}>{error}</p>}
              {successMessage && (
                <p className={styles.successText}>{successMessage}</p>
              )}

              <div className={styles.twoCol}>
                <div className={styles.inputShell}>
                  <input
                    type="text"
                    className={styles.input}
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>
                <div className={styles.inputShell}>
                  <input
                    type="text"
                    className={styles.input}
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className={styles.inputShell}>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="Mobile Number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  required
                />
              </div>

              <div className={styles.inputShell}>
                <input
                  type="email"
                  className={styles.input}
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className={styles.row}>
                {/* Buttons: match the two rounded gradient buttons */}
                <button type="submit" className={styles.portalButton}>
                  Update
                </button>
              </div>
              <div className={styles.row}>
                <button
                  type="button"
                  className={styles.portalButton}
                  onClick={() =>
                    navigate(
                      `/change-password?userProfileId=${upId}&token=${tp}`
                    )
                  }
                >
                  Change Password
                </button>
              </div>
              <div className={styles.row}>
                {/* bottom back link (centered, tiny, red) */}
                <div
                  className={styles.backLink}
                  onClick={() => navigate(-1)}
                  role="button"
                >
                  Back
                </div>
                <div
                  className={styles.backLink}
                  onClick={() => navigate("/#/")}
                >
                  Log Out
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
